/* ============================================================================
   GT Predictive Search — layer over Dawn's stock predictive-search.js.

   Two concerns, both isolated to this file (stock predictive-search.js is left
   byte-identical to upstream):

   1) Minimum characters: only query after >= 2 characters.

   2) Unsupported-locale fallback. Shopify's predictive endpoint
      (/search/suggest) returns HTTP 417 "Unsupported buyer locale" for some
      storefront languages — notably Georgian (ka), this store's primary locale.
      Stock Dawn reacts by throwing (uncaught console error) and closing the
      dropdown, so the customer sees nothing. Here we catch that failure: no
      console error, no hung loading state, and we show a localized
      "View all results" affordance that links to the full search page (which
      works in every locale). English/Russian keep full predictive results.

   getSearchResults is reimplemented (not wrapped) so the failure path is fully
   controlled; the success path mirrors stock Dawn exactly (cache, abort,
   renderSearchResults). Guarded against double-inclusion.
   ------------------------------------------------------------------------- */
(function () {
  if (window.__gtPredictiveInit) return;
  window.__gtPredictiveInit = true;

  var MIN_CHARS = 2;

  function applyPatch() {
    var ctor = window.customElements && customElements.get('predictive-search');
    if (!ctor || !ctor.prototype) return false;

    var proto = ctor.prototype;
    if (proto.__gtPatched) return true;
    proto.__gtPatched = true;

    proto.getSearchResults = function (searchTerm) {
      var self = this;
      var term = (searchTerm == null ? '' : String(searchTerm)).trim();

      // 1) Minimum-characters gate — keep dropdown closed, keep Enter working.
      if (term.length < MIN_CHARS) {
        self.removeAttribute('loading');
        if (typeof self.close === 'function') self.close();
        return;
      }

      var queryKey = term.replace(' ', '-').toLowerCase();

      if (typeof self.setLiveRegionLoadingState === 'function') {
        self.setLiveRegionLoadingState();
      }

      if (self.cachedResults && self.cachedResults[queryKey]) {
        self.renderSearchResults(self.cachedResults[queryKey]);
        return;
      }

      fetch(
        routes.predictive_search_url +
          '?q=' +
          encodeURIComponent(term) +
          '&section_id=predictive-search',
        { signal: self.abortController.signal }
      )
        .then(function (response) {
          if (!response.ok) {
            var error = new Error(String(response.status));
            error.status = response.status;
            throw error;
          }
          return response.text();
        })
        .then(function (text) {
          var markup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;

          self.allPredictiveSearchInstances.forEach(function (instance) {
            instance.cachedResults[queryKey] = markup;
          });

          self.renderSearchResults(markup);
        })
        .catch(function (error) {
          // Intentional abort (superseded query) — do nothing.
          if (error && (error.code === 20 || error.name === 'AbortError')) return;

          // Any other failure (e.g. 417 unsupported-locale in ka, or a network
          // error): degrade gracefully to the localized "view all" fallback.
          // No re-throw — keeps the console clean.
          self.gtRenderFallback(term);
        });
    };

    proto.gtRenderFallback = function (term) {
      var label = this.getAttribute('data-gt-view-all-label') || '';
      var form = this.input && this.input.form;
      var action =
        (form && form.getAttribute('action')) ||
        (window.routes && window.routes.search_url) ||
        '/search';
      var href =
        action +
        (action.indexOf('?') === -1 ? '?' : '&') +
        'q=' +
        encodeURIComponent(term) +
        '&options%5Bprefix%5D=last';

      var listbox = document.createElement('div');
      listbox.id = 'predictive-search-results';
      listbox.setAttribute('role', 'listbox');

      var wrap = document.createElement('div');
      wrap.className = 'predictive-search__search-for-button gt-predictive__fallback';

      var link = document.createElement('a');
      link.className =
        'predictive-search__item predictive-search__item--term gt-predictive__view-all link link--text h5';
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');
      link.href = href;

      var span = document.createElement('span');
      span.textContent = label; // localized, set as text (no injection)
      link.appendChild(span);

      wrap.appendChild(link);
      listbox.appendChild(wrap);

      this.predictiveSearchResults.innerHTML = '';
      this.predictiveSearchResults.appendChild(listbox);
      this.setAttribute('results', true);
      this.removeAttribute('loading');
      if (typeof this.open === 'function') this.open();
    };

    return true;
  }

  if (!applyPatch() && window.customElements && customElements.whenDefined) {
    customElements.whenDefined('predictive-search').then(applyPatch);
  }
})();
